import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import TheoryExamplesRunner from "../../components/TheoryExamplesRunner";

export default function CylinderConePreparationTheory() {
  const intro = (
    <div className="space-y-3">
      <p>
        Podstawą walca i stożka jest koło, dlatego najpierw obliczamy
        <InlineMath math={String.raw`P_p=\pi r^2`} />. Następnie korzystamy z
        odpowiedniego wzoru na objętość.
      </p>
      <BlockMath math={String.raw`V_{\text{walca}}=\pi r^2H,\qquad V_{\text{stożka}}=\frac13\pi r^2H`} />
      <p>
        Jeżeli walec i stożek mają takie same podstawy i wysokości, objętość
        stożka stanowi jedną trzecią objętości walca.
      </p>
      <BlockMath math={String.raw`P_c^{\text{walca}}=2\pi r^2+2\pi rH`} />
      <BlockMath math={String.raw`P_c^{\text{stożka}}=\pi r^2+\pi rl,\qquad l^2=r^2+H^2`} />
      <p>
        W stożku <InlineMath math="l" /> oznacza tworzącą. Gdy nie jest podana,
        zwykle wyznaczamy ją z twierdzenia Pitagorasa.
      </p>
    </div>
  );

  const examples = [
    {
      label: "Przykład 1",
      summary: "Objętość walca",
      description: "Promień podstawy wynosi 3, a wysokość 8.",
      content: <BlockMath math={String.raw`V=\pi r^2H=\pi\cdot3^2\cdot8=72\pi`} />,
    },
    {
      label: "Przykład 2",
      summary: "Objętość stożka",
      description: "Promień podstawy wynosi 3, a wysokość 8.",
      content: <BlockMath math={String.raw`V=\frac13\pi r^2H=\frac13\cdot\pi\cdot3^2\cdot8=24\pi`} />,
    },
    {
      label: "Przykład 3",
      summary: "Walec i stożek o tych samych wymiarach",
      description: "Objętość walca wynosi 90π.",
      content: <BlockMath math={String.raw`V_{\text{stożka}}=\frac13V_{\text{walca}}=\frac13\cdot90\pi=30\pi`} />,
    },
  ];

  return <TheoryExamplesRunner intro={intro} examples={examples} />;
}
